import { OpDistributor } from '../core/op-distributor'

export class ActiveDistributorsInfo {
    public count: number
    public multiple: boolean
    public singleActiveDistributor: OpDistributor
    public get singleDistributor(): string {
        return this.singleActiveDistributor ? this.singleActiveDistributor.name : null
    }
    public proccessDone: boolean

    constructor() {
        this.count = 0
        this.proccessDone = false
    }
}